module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAY1BMVEUAAAB5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGt5wGuYb94lAAAAIHRSTlMA9s3fu/KHYzMh7NvGwLKtkXhKKe/p1X5oURamckA+DHujh/kAAACuSURBVDjL7ZBJEoQgDEWjqIDzPPX073/KDna50CJ9AX2bH4qXQIVuroqdK+3SlI3551VgQqXC1KUVvQkHQslbcWIRxOSoySMHnOm83huOKPsFHLVXrME8iUIgMGRiPo1eseCblLMFKo4HuMErujdjzgbIXZ8optvfujbgmDrWXZ+PHgdkEcygdifYKnHf2ZzkPVtjrd2CSvLyKrYZH2tXohxQmiTaMtnLJdJ0c02+ltUZSEJy6uAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/discord.png
// module id = RpUu
// module chunks = 2